// 教学评价
const myReport = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaAluate/myReport/MyReport.vue')
//课堂评价
const ClassroomRecord = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/classroomRecord/ClassroomRecord.vue')
// 课堂评价-
 // 评价学生
const evaStudentWrap = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/classroomRecord/evaStudentWrap.vue')
const evaStudent = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/classroomRecord/evaStudent.vue')
// 选择学生
const choiceStudent = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/classroomRecord/choiceStudent.vue')
 // 评价统计
const evaStatistics = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/classroomRecord/evaStatistics.vue')

 // 我的课堂评价
const evaMyeva = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/classroomRecord/evaMyeva.vue')
//德育评价
const MoralEducationRecord = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/MoralEducationRecord.vue')

// 教师评价
const EvaTeacher = () => import(/* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaTeacher/EvaTeacher.vue')
const MyReportTeacher = () => import(/* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaTeacher/MyReport.vue')
const SetupTeacher = () => import(/* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaTeacher/Setup.vue')

// 综合素质评价
const SynthesizeQuality = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaAluate/synthesizeQuality/SynthesizeQuality.vue')
const SearchParameter = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaAluate/synthesizeQuality/SearchParameter.vue')
const ScoreDetails = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaAluate/synthesizeQuality/ScoreDetails.vue')
const SearchList = () => import( /* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaAluate/synthesizeQuality/SearchList.vue')

// 学生评教
const EvaOfTeacher = () => import(/* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaStudentOfTeacher/evaOfTeacher/EvaOfTeacher.vue')
const EvaOfTeacherDetails = () => import(/* webpackChunkName: "evaluation" */ '@/pages/evaluation/views/evaStudentOfTeacher/evaOfTeacher/Details.vue')

const evaluation = [
  {
    path: 'myReport',
    name: 'myReport',
    component: myReport,
  },
  {
    path: 'classroomRecord',
    name: 'classroomRecord',
    component: ClassroomRecord,
  },
  {
    path: 'evaStudentWrap',
    name: 'evaStudentWrap',
    component: evaStudentWrap,
  },
  {
    path: 'evaStudent',
    name: 'evaStudent',
    component: evaStudent,
  },
  {
    path: 'choiceStudent',
    name: 'choiceStudent',
    component: choiceStudent,
  },
  {
    path: 'evaMyeva',
    name: 'evaMyeva',
    component: evaMyeva,
  },
  {
    path: 'evaStatistics',
    name: 'evaStatistics',
    component: evaStatistics,
  },
  {
    path: 'MoralEducationRecord',
    name: 'MoralEducationRecord',
    component: MoralEducationRecord,
  },
  {
    path: 'evaTeacher',
    name: 'evaTeacher',
    component: EvaTeacher,
    children: [
      {
        path: 'myReportTeacher',
        name: 'myReportTeacher',
        component: MyReportTeacher,
      },
      {
        path: 'setupTeacher',
        name: 'setupTeacher',
        component: SetupTeacher,
      }
    ]
  },

  // 智慧评价
  {
    path: 'synthesizeQuality',
    name: 'synthesizeQuality',
    component: SynthesizeQuality,
    children: [
      {
        path: 'searchParameter',
        name: 'searchParameter',
        component: SearchParameter
      },
      {
        path: 'scoreDetails',
        name: 'scoreDetails',
        component: ScoreDetails
      },
      {
        path: 'searchList',
        name: 'searchList',
        component: SearchList,
      }
    ]
  },

  //学生评教
  {
    path: 'evaOfTeacher',
    name: 'evaOfTeacher',
    component: EvaOfTeacher,
  },
  {
    path: 'evaOfTeacherDetails',
    name: 'evaOfTeacherDetails',
    component: EvaOfTeacherDetails,
  },
  

]
export default evaluation;
